import api from '../api';
import ApiConstant from '../../constants/api.constants';
import { OrderDashboardModel } from '../../models/dashboard/order-dashboard-model';
import { get } from 'http';

const getDashboardProductionCardSummary = async (posId: any) => {
  try {
    const response = await api.get(`${ApiConstant.getDashboardProductionCardSummary}${posId}`);
    return response?.data || null;
  } catch (error) {
    console.error('Error fetching dashboard production card summary:', error);
    return null;
  }
};

const getDashboardInventoryCardSummary = async () => {
  try {
    const response = await api.get(`${ApiConstant.getDashboardInventoryCardSummary}`);
    return response?.data || null;
  } catch (error) {
    console.error('Error fetching dashboard inventory card summary:', error);
    return null;
  }
};

const getDashboardpurchaseSummary = async (posId: any, financialYear?: number) => {
  try {
    const base = `${ApiConstant.getDashboardpurchaseSummary}${posId}`;
    const url = (financialYear || financialYear === 0)
      ? `${base}&financialYear=${financialYear}`
      : base;
    const response = await api.get(url);
    return response?.data || null;
  } catch (error) {
    console.error('Error fetching dashboard purchase summary:', error);
    return null;
  }
};

const getDashboardRevenueSummary = async (year?: number) => {
  try {
    const url = year
      ? `${ApiConstant.getDashboardRevenueSummary}?financialYear=${year}`
      : ApiConstant.getDashboardRevenueSummary;
    const response = await api.get(url);
    return response?.data || null;
  } catch (error) {
    console.error('Error fetching dashboard revenue summary:', error);
    return null;
  }
};

const getDashboardCustomerSummary = async () => {
  try {
    const response = await api.get(`${ApiConstant.getDashboardCustomerSummary}`);
    return response?.data || null;
  } catch (error) {
    console.error('Error fetching dashboard customer summary:', error);
    return null;
  }
};

const getDashboardOrderSummary = async (): Promise<OrderDashboardModel | null> => {
  try {
    const response = await api.get<OrderDashboardModel>(`${ApiConstant.getDashboardOrderSummary}`);
    return response?.data || null;
  } catch (error) {
    console.error('Error fetching dashboard order summary:', error);
    return null;
  }
};

const getDashboardQualityCardSummary = async () => {
  try {
    const response = await api.get(`${ApiConstant.getDashboardQualityCardSummary}`);
    return response?.data || null;
  } catch (error) {
    console.error('Error fetching dashboard quality card summary:', error);
    return null;
  }
};

const getDashboardRevenueHeader = async () => {
  try {
    const response = await api.get(`${ApiConstant.getdashboardrevenueheader}`);
    return response?.data || null;
  } catch (error) {
    console.error('Error fetching dashboard revenue header:', error);
    return null;
  }
};



const DashboardService = {
  getDashboardProductionCardSummary,
  getDashboardInventoryCardSummary,
  getDashboardpurchaseSummary,
  getDashboardRevenueSummary,
  getDashboardCustomerSummary,
  getDashboardOrderSummary,
  getDashboardQualityCardSummary,
  getDashboardRevenueHeader
};

export default DashboardService;
